import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { CallCenterShift } from "../call-center-shift";
import { CallCenterVolunteer } from "../call-center-volunteer";
import { Organization } from "../organization";
import { CallCenterAlertEntityConfig } from "./config";
import { CallCenterAlertFilters } from "./filters";
import { CallCenterAlertMethods } from "./methods";

export const CALL_CENTER_ALERT_TYPES = [
  "DISTRESS",
  "EARLY_LEAVE",
  "CALL_COORDINATOR",
] as const;

export type CallCenterAlertType = (typeof CALL_CENTER_ALERT_TYPES)[number];

export const CALL_CENTER_ALERT_STATUSES = ["OPEN", "RESOLVED"] as const;

export type CallCenterAlertStatus =
  (typeof CALL_CENTER_ALERT_STATUSES)[number];

@HyperEntity<CallCenterAlert>("call-center-alert", CallCenterAlertEntityConfig)
export class CallCenterAlert extends extender(
  CallCenterAlertFilters,
  CallCenterAlertMethods,
) {
  @Fields.id()
  id = "";

  @Fields.string({ dbName: "organization_id", caption: "ארגון" })
  organizationId = "";

  @Relations.toOne(() => Organization, "organizationId")
  organization?: Organization;

  @Fields.string({ dbName: "volunteer_id", caption: "מתנדב" })
  volunteerId = "";

  @Relations.toOne(() => CallCenterVolunteer, "volunteerId")
  volunteer?: CallCenterVolunteer;

  @Fields.string({ dbName: "shift_id", allowNull: true, caption: "משמרת" })
  shiftId?: string;

  @Relations.toOne(() => CallCenterShift, "shiftId")
  shift?: CallCenterShift;

  @Fields.string({
    dbName: "station_manager_id",
    allowNull: true,
    caption: "מנהל עמדה",
  })
  stationManagerId?: string;

  @Fields.string({
    dbName: "opportunity_id",
    allowNull: true,
    caption: "משימה",
  })
  opportunityId?: string;

  @Fields.literal(() => CALL_CENTER_ALERT_TYPES, { caption: "סוג" })
  type: CallCenterAlertType = "DISTRESS";

  @Fields.literal(() => CALL_CENTER_ALERT_STATUSES, { caption: "סטטוס" })
  status: CallCenterAlertStatus = "OPEN";

  @Fields.string({ allowNull: true, caption: "סיבה" })
  reason?: string;

  @Fields.date({ dbName: "resolved_at", allowNull: true, caption: "נפתר" })
  resolvedAt?: Date;

  @Fields.string({
    dbName: "resolved_by_id",
    allowNull: true,
    caption: "נפתר על ידי",
  })
  resolvedById?: string;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();
}
